import client from "./client";

const endpoint = "feedback/";

const getActiveFeedbackQuestions = () => client.get(`${endpoint}questions/active`);

const submitFeedbackResponse = ({ body }) => client.post(`${endpoint}responses`, body);

const searchFeedbackEmployees = (q) =>
  client.get(`${endpoint}employees/search`, { q, limit: 10 });

export {
  getActiveFeedbackQuestions,
  submitFeedbackResponse,
  searchFeedbackEmployees,
};
